const formats = {
   Tabla: 'MMM DD, YYYY',
   DateTimePicker: 'MMMM DD, YYYY',
   default: 'YYYY-MM-DD'
};

const defaultFechaNull = '0001-01-01T00:00:00';
const defaultFecha = '1900-01-01T00:00:00';

export {
   formats,
   defaultFechaNull,
   defaultFecha,
};
